import { ConfigOption, MyContentWindow } from './types';

let procedures: any = null;

export function getProcedures() {
  if (!procedures) {
    const iframe = document.querySelector('#iframe_model') as HTMLIFrameElement;
    if (iframe) {
      const windowFrame = iframe.contentWindow as MyContentWindow;
      if (windowFrame) {
        const procedures = windowFrame?.v3d?.puzzles?.procedures;
        if (procedures) {
          return procedures;
        }
      }
    }
  }
  return procedures;
}

export function delay(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export const generateFabricId = () => {
  return Math.random().toString().slice(0, 5);
};

export function base64URLtoFile(base64String: string, filename: string) {
  try {
    if (!base64String.startsWith('data:')) {
      throw new Error('Invalid data URL format');
    }
    // Pre-process to remove redundant parts (assuming image data URL)
    const parts = base64String.split(';');
    if (parts.length < 2) {
      throw new Error('Invalid data URL format');
    }
    const mimeType = parts[0].split(':')[1].trim(); // Extract and trim MIME type
    const base64Data = parts[1].split(',')[1]; // Extract base64 data
    const bstr = atob(base64Data);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mimeType });
  } catch (error) {
    console.log(error);
  }
}

export const getConfigName = (id: string, type: 'procedure' | 'name') => {
  if (type === 'procedure') {
    switch (id) {
      case 'fabric':
        return 'changeFabric';
      case 'inner-fabric':
        return 'changeInnerFabric';
      case 'collar':
        return 'changeCollar';
      case 'cuff':
        return 'changeCuff';
      case 'placket':
        return 'changePlacket';
      case 'pocket':
        return 'changePocket';
      case 'back-pleats':
        return 'changeBackPleats';
      case 'stitch':
        return 'changeStitch';
      case 'monogram':
        return 'changeMonogram';
      default:
        return '';
    }
  } else {
    switch (id) {
      case 'fabric':
        return 'Fabric';
      case 'inner-fabric':
        return 'Inner Fabric';
      case 'collar':
        return 'Collar';
      case 'cuff':
        return 'Cuff';
      case 'placket':
        return 'Placket';
      case 'pocket':
        return 'Pocket';
      case 'back-pleats':
        return 'Back Pleats';
      case 'stitch':
        return 'Stitch';
      case 'monogram':
        return 'Monogram';
      default:
        return '';
    }
  }
};

export const deepCopy = <T>(obj: T): T => {
  return JSON.parse(JSON.stringify(obj));
};

export const getImagePath = (img?: string) => {
  if (img?.includes('http') || img?.includes('https')) {
    return img;
  } else {
    let href = window.location.href;
    let newHref = href?.split('/');
    if (href.includes('.html')) {
      newHref = href?.split('/').slice(0, -1);
    }
    if (img) {
      let ext;
      let name;
      if (img.includes('.')) {
        const splitDot = img?.split('.');
        name = splitDot[0];
        ext = splitDot[splitDot.length - 1];
      }
      return `${newHref.join('/')}/${name}.${ext || 'jpg'}`;
    }
  }
  return '';
};

export const quickSort = (array: ConfigOption[]): ConfigOption[] => {
  if (array.length <= 1) {
    return array;
  }
  const pivot = array[array.length - 1];
  const left = [];
  const right = [];

  for (const item of array.slice(0, -1)) {
    if (item.name.localeCompare(pivot.name) < 0) {
      left.push(item);
    } else {
      right.push(item);
    }
  }
  return [...quickSort(left), pivot, ...quickSort(right)];
};

export function resizeBase64Img(
  base64: string,
  maxWidth: number,
  maxHeight: number
): Promise<string> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = base64;
    img.onload = () => {
      let width = img.width;
      let height = img.height;

      // Tính toán kích thước mới dựa trên tỷ lệ
      if (width > height) {
        if (width > maxWidth) {
          height *= maxWidth / width;
          width = maxWidth;
        }
      } else {
        if (height > maxHeight) {
          width *= maxHeight / height;
          height = maxHeight;
        }
      }

      // Tạo canvas để resize ảnh
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.drawImage(img, 0, 0, width, height);
      }
      resolve(canvas.toDataURL()); // Returns the resized image as a base64 string
    };
    img.onerror = (error) => reject(error);
  });
}

export function toBase64(file: File) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
